import React, { Component } from 'react';
import { Button, Input, Select, DatePicker } from 'antd';
import moment from 'moment';
import '../style.less';

const Option = Select.Option;
const InputGroup = Input.Group;
const dateFormat = 'YYYY-MM-DD';

class Filter extends Component {
    state = {
        searchParams: {},
    }

    search = () => {
        const { searchParams, select } = this.state;
        const { createTime, hospitalName, isCooperation, hospitalHasMember } = searchParams;
        const createTimeIsEmpty = 1;
        if (select == "为空") {
            const params = {
                createTimeIsEmpty,
                hospitalName,
                hospitalHasMember,
                isCooperation,
            }
            this.props.search(params);
        } else {
            const params = {
                createTime,
                hospitalName,
                hospitalHasMember,
                isCooperation,
            }
            this.props.search(params);
        }
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode == 13) {
            this.search();
        }
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    saveSelect = (value) => {
        this.setState({ select: value });
        if (value == "为空") {
            const { searchParams } = this.state;
            searchParams["createTime"] = "";
            this.setState({ searchParams });
        }
    }

    back = () => {
        history.go(-1)
    }

    handleMonthChange = (date, dateString, field) => {
        const { searchParams } = this.state;
        searchParams[field] = dateString;
        this.setState({ searchParams });
    }

    render() {
        const { searchParams, select } = this.state;
        const { hospitalName, hospitalHasMember, isCooperation } = searchParams;
        const { createTime = "" } = searchParams;
        const { curRole } = sessionStorage;
        const showExportButton = curRole !== 'CRC';
        return (
            <div className="search-bar" style={{ marginBottom: 10 }}>
                <div className="search-item">
                    <label className="ui-label">更新时间</label>
                    <InputGroup compact>
                        <Select
                            defaultValue="GT"
                            onChange={(value) => this.saveSelect(value)}
                        >
                            <Option value="GT" style={{ textAlign: "center" }}>大于</Option>
                            <Option value="为空" style={{ textAlign: "center" }} >为空</Option>
                        </Select>
                        <DatePicker
                            format={dateFormat}
                            placeholder="请选择"
                            style={{ width: 120 }}
                            disabled={select == "为空"}
                            onChange={(date, dateString) => this.handleMonthChange(date, dateString, 'createTime')}
                            value={createTime ? moment(createTime) : null}
                            allowClear={true}
                        />
                    </InputGroup>
                </div>
                <div className="search-item">
                    <label className="ui-label">医院名称</label>
                    <Input value={hospitalName} placeholder="请输入" onChange={e => this.handleInputChange(e, 'hospitalName')} />
                </div>
                <div className="search-item">
                    <label className="ui-label">是否已配置SSU负责人</label>
                    <Select
                        style={{ width: 80 }}
                        placeholder="请选择"
                        value={hospitalHasMember}
                        onKeyPress={this.enterSearch}
                        onChange={(value) => this.handleSelectChange(value, 'hospitalHasMember')}
                    >
                        <Option value="1" >是</Option>
                        <Option value="0" >否</Option>
                    </Select>
                </div>
                {showExportButton && <div className="search-item">
                    <label className="ui-label">与津石是否有合作</label>
                    <Select
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={(value) => this.handleSelectChange(value, 'isCooperation')}
                        value={isCooperation}
                        placeholder="请选择"
                    >
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </div>}
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    {showExportButton && <Button type="primary" onClick={this.export}>导出</Button>}
                    <Button type="primary" onClick={this.back} style={{ background: '#62cf96', border: '1px solid #00a854' }}>返回</Button>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/hospital/ssuLog/Filter.js